import { useBrand } from '../context/BrandContext';
import FastestFormCRMObjectList from './fastestform/CRMObjectList';
import AbleCRMObjectList from './able/CRMObjectList';

export default function CRMObjectList() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleCRMObjectList /> : <FastestFormCRMObjectList />;
}
